import { useTheme } from "@emotion/react";
import { Container, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import ImageGeneratorToolbar from "components/images/generator/ImageGeneratorToolbar";
import { useDispatch, useSelector } from "react-redux";
import { imageStudioActions } from "store/imageStudio";
import GenerateImageButton from "components/images/generator/GenerateImageButton";
import ImagePreviews from "components/images/ImagePreviews";
import GenerationGallery from "components/images/GenerationGallery";
import { fonts } from "fonts";
import ModelSelectorMenu from "components/images/ModelSelectorMenu";
import {
  DOWNLOAD_IMAGE_MENU_ITEM,
} from "components/images/imageUtils";
export default function ImageGenerator() {

  const images = useSelector((state) => state.imageStudio.images);
  const model = useSelector((state) => state.imageStudio.model);

  const theme = useTheme();
  const dispatch = useDispatch();
  const prompt = useSelector((state) => state.imageStudio.prompt);

  const handleEdit = (imageGeneration) => {
    dispatch(imageStudioActions.edit(imageGeneration));
  };

  const handleUserPrompt = (imageGeneration) => {
    dispatch(imageStudioActions.usePrompt(imageGeneration));
  };

  const menuItems = [
    DOWNLOAD_IMAGE_MENU_ITEM,
    {
      label: "Use Prompt",
      action: handleUserPrompt,
    },
    {
      label: "Edit",
      action: handleEdit,
    }
  ];

  return (
    <Stack
      spacing={3}
      alignItems="center"
      justifyContent="center"
      sx={{
        overflowX: "hidden",
      }}
      border="1px solid"
      width="100%"
    >
      <Container maxWidth="sm">
        <Stack spacing={1} py={1}>
          <ImagePreviews images={images} bucketName={"imageStudioInputs"} />
          <ImageGeneratorToolbar />
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography
              sx={{
                color: theme.palette.text.main,
              }}
              fontFamily={fonts.anton}
            >
              Model
            </Typography>

            <ModelSelectorMenu
              model={model}
              setModel={(model) => dispatch(imageStudioActions.setModel(model))}
            />
          </Stack>
          <Stack direction="row">
            <TextField
              fullWidth
              maxRows={6}
              multiline
              placeholder="What do you want to generate?"
              color="secondary"
              InputProps={{
                style: {
                  backgroundColor: theme.palette.inputBackground.main,
                  color: theme.palette.text.main,
                },
              }}
              value={prompt}
              onChange={(event) =>
                dispatch(imageStudioActions.setPrompt(event.target.value))
              }
            />
          </Stack>

          <GenerateImageButton />
        </Stack>
      </Container>

      <GenerationGallery menuItems={menuItems} />
    </Stack>
  );
}
